import { ClientConfig } from '../../config/ClientConfig'
import { HttpService } from '../../services/http-service'
import {
	CasinoGameInfo,
	getStaticCasinoGameInfoById,
} from '../../config/CasinoConfig'
import { getGeoHeaders } from '../../services/GeoLocationService'

export const CasinoManagementApi = new class {

	async getPlayableCasinoGames(): Promise<CasinoGameConfig[]> {
		const url = `${ClientConfig.CASINO_MANAGEMENT_URL}/casino-games`
		const headers = getGeoHeaders()
		return HttpService.get<CasinoGameConfigResponse[]>(url, {
			authenticate: true,
			...(headers && { headers }),
		}).then(configs => {
		  return configs
			.filter(c => getStaticCasinoGameInfoById(c.id, c.provider))
			.map(mapFromResponse)
		})
	}
}()

export interface CasinoGameConfigResponse {
    id: string;
    enabled: boolean;
    flag: string;
		provider: string;
}

export interface CasinoGameConfig {
    id: string;
    enabled: boolean;
    flag: string;
		provider: string;
    info: CasinoGameInfo;
}

const mapFromResponse = (config: CasinoGameConfigResponse) : CasinoGameConfig => {
    const info = getStaticCasinoGameInfoById(config.id, config.provider as string)
    return {
        ...config,
        info
    }
}
